import { render, staticRenderFns } from "./PropertyManagement.vue?vue&type=template&id=de567b8c&"
import script from "./PropertyManagement.vue?vue&type=script&lang=js&"
export * from "./PropertyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports